import { useQueryClient } from '@tanstack/react-query';
import { queryKeys, retryPayment, useBusyAction } from '@vgrubs/components';

/**
 * The Client Payments retry, for a failed monthly SaaS payment (its id is the
 * client payment id). The retry moves the payment out of `failed`, so every
 * tab's count and list is refetched.
 */
export const useRetrySaasPayment = () => {
  const queryClient = useQueryClient();
  const { busy, run } = useBusyAction();

  return {
    busy,
    retry: (id: number) =>
      run(async () => {
        await retryPayment(id);
        queryClient.invalidateQueries({
          queryKey: queryKeys.admin.saasDetails.all,
        });
      }, 'Payment retried.'),
  };
};
